export default __webpack_public_path__ + "static/media/janni.771a8973.png";